import React, { useState, useContext, useEffect } from "react";
// @ts-ignore
import { LocalizationContext } from "react-localize";
// Styles
import "./travelex.sass";
import TravelInsurenceConfirmModal from "./TravelInsurenceConfirmModal";
import { filterReservationsByCheckInDate } from "./travelexUtils";
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";
import travelexArrow from "./static/images/icon-up-right.png";
import travelexClose from "./static/images/modal-close.png";
import { getStoredCountry } from "Components/rokt/HelperMethods";
import { ReactAppMode } from "Interfaces/ReactAppModes";
import { EXEC_MODE } from "cfg";
import { ScreenType } from "Constants";
import { ReservationType } from "Interfaces/GetReservations";

interface Props {
  reservationsData: any;
  setScreenType(
    screenType: ScreenType,
    aypResId?: number,
    waitListId?: number,
    reservationType?: ReservationType
  ): void;
}

const TravelexInsurenceCardComponent: React.FC<Props> = ({
  reservationsData,
  setScreenType,
}) => {
  const { localize }: any = useContext(LocalizationContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hideBanner, setHideBanner] = useState(false);
  const [isFromSsoToMvc, setIsFromSsoToMvc] = useState(false);
  const ChkCloseBanner = sessionStorage.read("travelexInsurenceBanner");
  const hashFragment = window.location.hash;
  const previousHash = sessionStorage.read("travelexHashFragment");
  if (previousHash !== hashFragment) {
    sessionStorage.write("travelexHashFragment", hashFragment);
    sessionStorage.remove("travelexInsurenceBanner");
  }
  const qsiHistoryRaw = sessionStorage.read("QSI_History");
  useEffect(() => {
    if (qsiHistoryRaw) {
      //   // Parse the stored JSON
      const qsiHistory = JSON.parse(qsiHistoryRaw) || {};
      //   // Check if PageReferrer contains "myritzcarltonclub"
      if (
        qsiHistory.PageReferrer &&
        qsiHistory.PageReferrer.includes("myritzcarltonclub")
      ) {
        setIsFromSsoToMvc(true);
      } else {
        setIsFromSsoToMvc(false);
      }
    }
  }, [qsiHistoryRaw]);
  const isNotUSAddress = getStoredCountry() === "USA" ? false : true;

  const isClosewBanner =
    ChkCloseBanner && ChkCloseBanner === "close" ? true : false;
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const closeBanner = () => {
    sessionStorage.write("travelexInsurenceBanner", "close");
    setHideBanner(true);
  };
  const handleLearnMore = () => {
    window.location.href = "/timeshare/mvco/cash/post-departure-insurance";
  };

  const handleYesClick = () => {
    // window.location.href = "http://departure.insurancebytravelex.com/";
    window.open(
      "https://departure.insurancebytravelex.com/?utm_source=internal&utm_medium=link&utm_campaign=MVC_Res",
      "_blank"
    );
    setIsModalOpen(false);
  };
  const handleClickResDetail = (resDetail: any) => {
    const resId: any = resDetail.reservationID;
    const resType: any = "UPCOMING";
    sessionStorage.write("reservationType", "UPCOMING");

    // window.location.href = `/viewReservation.jsp?resId=${resId}&resType=${resType}`;
    if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
      setScreenType(ScreenType.VIEW_RESERVATION, resId, undefined, resType); // 1C code add undefined parameter
    } else {
      // VCAP (production)
      window.location.href = `/viewReservation.jsp?resId=${resId}&resType=${resType}`;
    }
  };
  const filteredReservations =
    filterReservationsByCheckInDate(reservationsData);
  if (isClosewBanner || isNotUSAddress || isFromSsoToMvc) {
    return <></>;
  }
  return (
    <div className="main-travelex-card-component">
      {isModalOpen && (
        <TravelInsurenceConfirmModal
          onClose={closeModal}
          onYes={handleYesClick}
        />
      )}
      <div className="travelex-banner-wrapper">
        <div className="travelex-inner-card-wrapper">
          <div className="travelex-info-wrapper">
            <div className="travelex-info-inner-wrapper">
              <div className="travelex-info-group-text">
                <div className="travelex-info-header">
                  <div className="travelex-info-title-text">
                    {localize("static.content.post-departure-banner-header")}
                  </div>
                </div>
                {filteredReservations.map((reservation: any, index: any) => (
                  <div
                    className="travelex-info-name-link"
                    onClick={() =>
                      handleClickResDetail(reservation.reservationDetails)
                    }
                    key={index}
                  >
                    {`${reservation.reservationDetails.resortName}, ${reservation.reservationDetails.resortLocation}`}
                  </div>
                ))}
                <div
                  className="travelex-card-info-msg"
                  dangerouslySetInnerHTML={{
                    __html: localize(
                      "static.content.post-departure-banner-description"
                    ),
                  }}
                ></div>
              </div>
              <div className="travelex-card-btn-footer">
                <div className="travelex-enrollNow-btn" onClick={openModal}>
                  {localize(
                    "static.content.post-departure-banner-primary-cta-label"
                  )}

                  <img src={travelexArrow} alt="uarrow Logo" />
                </div>
                <div
                  className="travelex-LearnMore-btn"
                  onClick={handleLearnMore}
                >
                  {localize(
                    "static.content.post-departure-banner-secondary-cta-label"
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="travelex-img-wrapper">
            <img
              src={localize("travelex-banner-logo-path")}
              alt="Travelex Logo"
            />
          </div>
        </div>
        <div className="banner-close-wrapper" onClick={closeBanner}>
          <img src={travelexClose} alt="close Logo" />
        </div>
      </div>
    </div>
  );
};

export { TravelexInsurenceCardComponent };
